import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';

import { Hero } from './sections/Hero';
import { ProblemSolution } from './sections/ProblemSolution';
import { Features } from './sections/Features';
import { ProductShowcase } from './sections/ProductShowcase';
import { Pricing } from './sections/Pricing';
import { FAQ } from './sections/FAQ';
import { FinalCTA } from './sections/FinalCTA';

import { Page } from './styles';

const nav = [
  { label: 'Solução', href: '#solucao' },
  { label: 'Recursos', href: '#recursos' },
  { label: 'Planos', href: '#precos' },
  { label: 'FAQ', href: '#faq' },
];

const Homepage: React.FC = () => {
  const location = useLocation();

  // Links do footer/header pra seções desta página usam `/#id` -- em SPA,
  // navegar de OUTRA página pra cá com um hash não rola a tela sozinho
  // (só um reload de página real faz isso nativamente), e clicar de novo
  // já estando aqui só troca o hash sem re-renderizar a rota. Cobre os
  // dois casos rolando manualmente sempre que o hash muda.
  useEffect(() => {
    if (!location.hash) return;

    const target = document.querySelector(location.hash);
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [location.hash]);

  return (
    <>
      {/* Fora de `Page`: `overflow-x: hidden` em qualquer ancestral
          quebra `position: sticky` no Header (regra do CSS, não bug de
          especificidade) -- por isso o header não ficava fixo nem
          reagia ao scroll antes. */}
      <Header nav={nav} ctaLabel="Teste grátis" ctaHref="#cta" />

      <Page>
        <Hero />
        <ProblemSolution />
        <Features />
        <ProductShowcase />
        <Pricing />
        <FAQ />
        <FinalCTA />

        <Footer />
      </Page>
    </>
  );
};

export { Homepage };
